import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { globalTheme as GlobalColors } from '@playbookux/playbook-web-core';
import {
  Container,
  ContainerLeftSide,
  ContainerRightSide,
  ContainerResults,
  RecommendationBox,
} from './styles';

import SuccessFailureStats from '../success-failure-stats';
import ResultsBox from '../results-box';

const BarChartResults = (props) => {
  const { selectedTask } = props;

  // show recommendation if the total success rate is below 70%
  const showRecommendation = useMemo(() => {
    const { directSuccess, indirectSuccess } = selectedTask.statistics;
    return directSuccess.percentage + indirectSuccess.percentage < 70;
  }, [selectedTask.statistics]);

  return (
    <Container>
      <ContainerLeftSide>
        <SuccessFailureStats
          statistics={selectedTask.statistics}
        />
      </ContainerLeftSide>

      <ContainerRightSide>
        {showRecommendation && (
          <RecommendationBox>
            Your total success rate is below 70%. Consider reviewing its position.
          </RecommendationBox>
        )}
        <ContainerResults>
          <ResultsBox
            resultType="Success"
            directColor={GlobalColors.color.directSuccess}
            indirectColor={GlobalColors.color.indirectSuccess}
            directResult={selectedTask.statistics.directSuccess}
            indirectResult={selectedTask.statistics.indirectSuccess}
          />
          <ResultsBox
            resultType="Fail"
            directColor={GlobalColors.color.directFailure}
            indirectColor={GlobalColors.color.indirectFailure}
            directResult={selectedTask.statistics.directFailure}
            indirectResult={selectedTask.statistics.indirectFailure}
          />
        </ContainerResults>
      </ContainerRightSide>
    </Container>
  );
};

BarChartResults.propTypes = {
  selectedTask: PropTypes.shape({
    taskTitle: PropTypes.string,
    label: PropTypes.string,
    statistics: PropTypes.shape({
      directSuccess: PropTypes.shape({
        total: PropTypes.number,
        percentage: PropTypes.number,
      }),
      indirectSuccess: PropTypes.shape({
        total: PropTypes.number,
        percentage: PropTypes.number,
      }),
      directFailure: PropTypes.shape({
        total: PropTypes.number,
        percentage: PropTypes.number,
      }),
      indirectFailure: PropTypes.shape({
        total: PropTypes.number,
        percentage: PropTypes.number,
      }),
    }),
  }).isRequired,
};

export default BarChartResults;
